import React from "react";

import { useContext } from "react";
import Contexto from "../context/Contexto";
import { useState } from "react";

function EnviarReto(props) {
  const { programa } = props;
  const { Griseado, bajarCertificado, cliente, guardarDatos, mandarMensajes } =
    useContext(Contexto);
  const [mostrar, setMostrar] = useState("none");
  const [urlg, setUrlg] = useState("");
  const mostrarlos = () => {
    if (mostrar == "none") {
      setMostrar("block");
    } else {
      setMostrar("none");
    }
  };

  let urlguardar = (e) => {
    setUrlg(e.target.value);
  };
  let guardarlos = () => {
    let url = urlg;
    let retos = [];
    if (cliente.retosDS) {
      retos = cliente.retosDS.retos;
    }
    let nombresin = 1;
    if (cliente.retosDS) {
      nombresin = cliente.retosDS.retos.length + 1;
    }
    let retotxt = {
      nombre: `Reto ${nombresin}`,
      url: url,
      programa: programa,
    };

    let ref = `usuarios/${cliente.uid}/retosDS`;
    let otro = retotxt.url.split("/");
    retos.push(retotxt);
    if (otro[3] == "proto") {
      guardarDatos(ref, { retos });
    } else {
      mandarMensajes(
        "Recorda que solo tomamos url del tipo: https://www.figma.com/proto/"
      );
    }
  };

  return (
    <>
      {" "}
      <div
        className="blanco cursor"
        onClick={() => {
          mostrarlos();
        }}
      >
        MIS RETOS
      </div>
      <div className="enviarReto" style={{ display: mostrar }}>
        <div className="retitos">
          <input
            type="text"
            placeholder="Inserta tu reto aqui"
            onChange={urlguardar}
          />
          <br /> <br />
          <div
            className="blanco cursor"
            onClick={() => {
              guardarlos();
            }}
          >
            ENVIAR RETO
          </div>{" "}
          <br />
          <br />
          {cliente &&
            cliente.retosDS &&
            cliente.retosDS.retos.map((item, i) => {
              if (item.programa == programa) {
                return (
                  <>
                    <a href={item.url} key={i}>
                      {item.nombre}
                    </a>{" "}
                  </>
                );
              }
            })}
        </div>
      </div>
    </>
  );
}

export default EnviarReto;
